
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
})
export default class DisableableMixin extends Mixins() {
  @Prop({ default: false})
  disabled: boolean;

  @Prop({ default: "入力が禁止されています。" })
  disabledDescription: string;

  get shownDisabledDescription(): string {
    return this.disabled
      ? this.disabledDescription
      : "";
  }
}
